// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2VNRo","dragIcon":"Choice_dragIcon__3qp4h","left":"Choice_left__2Iu9d","input":"Choice_input__NkKmz"};